import { Button, Checkbox, Intent } from "@blueprintjs/core";
import moment from "moment";
import { useGridState, IDataTableColumn, FieldSet } from "nsitools-react";
import * as React from "react";
import { DashboardApi, DashboardSubTaskGridDto } from "../../../api";
import { CustomDataTable } from "../../../components";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";

export interface IMyTaskSubCardProps {
  data: DashboardSubTaskGridDto[];
}

export const MyTaskSubCard: React.FunctionComponent<IMyTaskSubCardProps> = (props) => {
  const { t } = useTl();
  const api = useApiService(DashboardApi);

  const { data } = props;

  const [dataState, setdataState] = React.useState(data.filter((e) => e.closedOn === null || e.closedOn === undefined));

  const [showClosed, setshowClosed] = React.useState(false);

  const getSubTasks = React.useCallback(
    (showAll: boolean) => {
      return showAll ? data : data.filter((e) => e.closedOn === null || e.closedOn === undefined);
    },
    [data]
  );

  const tableState = useGridState<any>({
    serverMode: false,
    enablePagination: false,
    enableFilter: false,
    data: dataState,
  });
  const close = React.useCallback(
    async (dashboardTaskId: number) => {
      await api.close(dashboardTaskId);
      let tasks = await getSubTasks(showClosed);
      const changes = tasks.find((c) => c.dashboardTaskId === dashboardTaskId);
      changes.closedOn = new Date();
      if (!showClosed) {
        tasks = tasks.filter((c) => c.dashboardTaskId !== dashboardTaskId);
      }

      setdataState([...tasks]);
    },
    [api, getSubTasks, showClosed]
  );

  React.useEffect(() => {
    if (tableState.data !== dataState) {
      tableState.setData(dataState);
    }
  }, [dataState, tableState]);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Task),
        fieldName: "task",
      },
      {
        header: () => t(ETLCodes.Finished),
        computed: true,
        disableSorting: true,
        fieldName: "onClosed",
        render: (item: DashboardSubTaskGridDto) => {
          if (item.closedOn) {
            return <div>{moment(item.closedOn).format("DD/MM/YYYY")}</div>;
          } else {
            return (
              <Button
                text={t(ETLCodes.Done)}
                minimal={false}
                intent={Intent.PRIMARY}
                onClick={() => {
                  close(item.dashboardTaskId);
                }}
              />
            );
          }
        },
      },
    ],
    [close, t]
  );
  return (
    <FieldSet
      title={t(ETLCodes.SubTasks)}
      rightElement={
        <Checkbox
          label={t(ETLCodes.ShowFinished)}
          checked={showClosed}
          onClick={async () => {
            const tasks = await getSubTasks(!showClosed);
            setshowClosed(!showClosed);
            setdataState(tasks);
          }}
        />
      }
    >
      <CustomDataTable tableState={tableState} columns={columns} renderNoData={<></>} />
    </FieldSet>
  );
};
